export default __webpack_public_path__ + "static/assets/57b4371e91c1437849b26b203afce50c.gif";